import React, { FC } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { ArrowBigRightIcon } from '@utils/iconsDefs';

type Props = {
  title: string;
  onBack?: () => void;
};

/**
 * The header title of a nested filter panel: the name of the list the panel
 * shows, led by a back chevron when the panel is stepped back from.
 *
 * The chevron is the house right chevron mirrored, since the barrel has no
 * left variant of that glyph. The button's accessible name is a plain "Back"
 * rather than a destination, because the same title heads a category's
 * values (back to the root), a criteria list (back to the root) and the
 * values beside that list (back to the list alone). With no `onBack` the
 * title stands alone.
 */
const FilterPanelBackTitle: FC<Props> = ({ title, onBack }) => (
  <Stack direction="row" alignItems="center" gap="4px" minWidth={0}>
    {onBack && (
      <IconButton onClick={onBack} aria-label="Back" sx={{ p: 0 }}>
        <ArrowBigRightIcon
          width={20}
          height={20}
          style={{ transform: 'scaleX(-1)' }}
        />
      </IconButton>
    )}

    <Typography variant="h5" color="grey.1000" noWrap>
      {title}
    </Typography>
  </Stack>
);

export default FilterPanelBackTitle;
